var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.5,
    r: 18,
    fill: "#0368A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7835 12.1621C22.2225 12.0499 21.4648 11.9661 20.9883 11.9661C19.698 11.9661 19.6142 12.5271 19.6142 13.4247V15.0226H22.8396L22.5585 18.3325H19.6142V28.4001H15.5757V18.3325H13.5V15.0226H15.5757V12.9752C15.5757 10.1709 16.8937 8.6001 20.2029 8.6001C21.3527 8.6001 22.1942 8.7684 23.2878 8.9928L22.7835 12.1621Z",
    fill: "#E4F2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e5ba13aaabe726438d9f8735d01d9bc7.svg";
export { ForwardRef as ReactComponent };